import comp from "./Unveil";
export default comp;
